import React from "react";
import { FiFacebook, FiTwitter, FiInstagram } from "react-icons/fi";
import { Link } from "react-router-dom";
import appLogo from "../../Media/zzz.png";
import "./footer.css";

const Footer = () => {
  return (
    <div>
      <div className="footer">
        <div className="footer-left">
          <h3>Contact Us</h3>
          <div className="contact-link">
            <FiFacebook /> Facebook
          </div>
          <div className="contact-link">
            <FiInstagram /> Instagram
          </div>
          <div className="contact-link">
            <FiTwitter /> Twitter
          </div>
        </div>
        <div className="footer-center">
          <img src={appLogo} height={70} alt="footer-logo" />
          <p>"We hope you Love yourself as much as we love you"</p>
          <h5>&copy; 2022 DepRelief</h5>
        </div>
        <div className="footer-right">
          <h3>Useful Links</h3>
          <p>How it Works</p>
          <p>Terms & Conditions</p>
          <p>Privacy Policy</p>
        </div>
      </div>
      {/* <div className="footer-emergency">
        <p>
          If you or any other person are feeling suicidal or are in immediate
          crisis - don't use this site.{" "}
          <Link to="/emergency">
            <span>These Resources</span>
          </Link>{" "}
          can provide you with immediate help worldwide.
        </p>
      </div> */}
    </div>
  );
};

export default Footer;
